import { Fragment } from 'react';
import type { Citation } from '../services/types';
import { SourceRow } from './SourceRow';

const POPOVER_MAX_HEIGHT_PX = 240;
const POPOVER_DIVIDER = 'rgba(255,255,255,0.1)';

interface CitationSourcesPopoverProps {
  citations: Citation[];
}

export const CitationSourcesPopover = ({
  citations,
}: CitationSourcesPopoverProps) => {
  return (
    <div
      className="caddietw-flex caddietw-flex-col caddietw-overflow-y-auto"
      style={{ maxHeight: POPOVER_MAX_HEIGHT_PX }}
    >
      {citations.map((citation, i) => (
        <Fragment key={`${citation.index}-${citation.url}`}>
          {i > 0 && (
            <div
              style={{
                height: 1,
                backgroundColor: POPOVER_DIVIDER,
                margin: '2px 0',
              }}
            />
          )}
          <SourceRow citation={citation} />
        </Fragment>
      ))}
    </div>
  );
};
